<template>
  <div class="wrapper">
    <div class="main visual-5 visual-7">
      <Header backRoute="/chose-option" />
      <div class="container">
        <div class="row">
          <div class="col-lg-5 col-md-5 col-sm-12">
            <div class="vis7-inr1">
              <ul>
                <li>
                  <h6>1</h6>
                </li>
                <li>
                  <h4>Scan QR Code</h4>
                  <p>Point the camera on your phone at this code</p>
                </li>
              </ul>
              <div class="qrrr">
                <!-- <router-link :to="'/good-to-go'"> -->
                <!-- <img
                  :src="qrData?.qrcode || '@/assets/img/qr-code-updated.jpeg'"
                  alt="QR Code"
                /> -->
                <img
                  :src="
                    qrData?.qrcode ||
                    require('@/assets/img/qr-code-updated.jpeg')
                  "
                  alt="QR Code"
                />
                <!-- </router-link> -->
                <h5>QR Code</h5>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-12 cntr-col">
            <img src="@/assets/img/vis7-img1.png" alt="" />
          </div>
          <div class="col-lg-5 col-md-5 col-sm-12">
            <div class="vis7-inr1">
              <ul>
                <li>
                  <h6>2</h6>
                </li>
                <li>
                  <h4>Enter Number in App</h4>
                  <p>Enter the number shown below in the Mamabots App</p>
                </li>
              </ul>
              <h3>{{ qrData?.qrcodeId || "7013-5297" }}</h3>
            </div>
          </div>
        </div>
      </div>
      <FooterView :showButtons="true" />
    </div>
  </div>
</template>

<script>
import { IdentityCodesService } from "@/services/identity-codes.service";
import FooterView from "@/layout/Footer.vue";
import Header from "@/layout/Header.vue";

export default {
  components: {
    FooterView,
    Header,
  },
  name: "ScanQR",
  data() {
    return {
      qrData: {}, // Data to hold the API response
      statusCheckInterval: null, // Interval reference
      pollingTimeout: null, // Timeout reference
    };
  },
  methods: {
    async fetchQRData() {
      try {
        const kioskId = this.$store.state.user.currentUser.objectId;
        const response = await IdentityCodesService.syncQRCodes(
          kioskId,
          this.$route.query.code
        ); // Fetch QR code
        this.qrData = response?.data;

        // ✅ Start polling only if QR Code ID exists
        if (this.qrData?.qrcodeId) {
          this.startStatusPolling(this.qrData.qrcodeId);
        }
      } catch (error) {
        console.error("Error fetching QR data:", error);
      }
    },

    // ✅ Start polling QR code status every 5 seconds, stop after 60
    startStatusPolling(qrcodeId) {
      this.statusCheckInterval = setInterval(async () => {
        try {
          const response = await IdentityCodesService.pollQRStatus(qrcodeId);
          const status = response?.data?.status;

          if (status === "booked") {
            this.stopPolling();
            this.$router.push("/good-to-go");
          }
        } catch (error) {
          console.error("Polling error:", error);
        }
      }, 5000); // Poll every 5 seconds

      // Stop polling after 60 seconds
      this.pollingTimeout = setTimeout(() => {
        this.stopPolling();
        console.log("Stopped polling after 60 seconds");
      }, 120000); // 60 seconds
    },

    // ✅ Stop polling (clear both interval and timeout)
    stopPolling() {
      if (this.statusCheckInterval) {
        clearInterval(this.statusCheckInterval);
        this.statusCheckInterval = null;
      }
      if (this.pollingTimeout) {
        clearTimeout(this.pollingTimeout);
        this.pollingTimeout = null;
      }
    },
  },

  mounted() {
    this.fetchQRData(); // Fetch data when the component is mounted
  },

  beforeUnmount() {
    this.stopPolling();
  },
};
</script>

<style scoped>
/* Add your styles here */
</style>
